import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["tooltip"]

  connect() {
    // Kein globaler Event Listener mehr - nur auf Icon-Klick reagieren
  }

  disconnect() {
    // Entferne Event Listener falls vorhanden
    if (this.boundClickOutside) {
      document.removeEventListener('click', this.boundClickOutside, true)
    }
  }

  clickOutside(event) {
    // Schließe Tooltip wenn außerhalb geklickt wird, aber nur wenn Tooltip sichtbar ist
    const tooltip = this.tooltipTargets[0]
    if (tooltip && tooltip.style.display !== 'none' && !this.element.contains(event.target) && !tooltip.contains(event.target)) {
      this.hide(event)
    }
  }

  show(event) {
    event.preventDefault()
    this.tooltipTargets.forEach(tooltip => {
      // Positioniere das Tooltip relativ zum Mauszeiger
      const rect = this.element.getBoundingClientRect()
      const tooltipRect = tooltip.getBoundingClientRect()
      
      // Positioniere oberhalb des Elements, zentriert
      tooltip.style.left = `${rect.left + (rect.width / 2) - (tooltipRect.width / 2)}px`
      tooltip.style.top = `${rect.top - tooltipRect.height - 10}px`
      
      tooltip.classList.remove('opacity-0', 'invisible')
      tooltip.classList.add('opacity-100')
    })
  }

  hide(event) {
    // Verhindere nicht das Event, nur verstecke das Tooltip
    this.tooltipTargets.forEach(tooltip => {
      tooltip.classList.add('opacity-0', 'invisible', 'pointer-events-none')
      tooltip.classList.remove('opacity-100', 'pointer-events-auto')
      tooltip.style.display = 'none'
    })
    
    // Event Listener entfernen wenn Tooltip versteckt ist
    if (this.boundClickOutside) {
      document.removeEventListener('click', this.boundClickOutside, true)
      this.boundClickOutside = null
    }
  }

  toggle(event) {
    // Nur auf Icon-Klick reagieren, nicht auf andere Klicks
    if (event && event.target !== this.element.querySelector('i.fa-info-circle')) {
      return
    }
    
    if (event) {
      event.stopPropagation() // Verhindere Bubbling nur für Icon-Klicks
    }
    
    this.tooltipTargets.forEach(tooltip => {
      if (tooltip.classList.contains('opacity-0') || tooltip.classList.contains('invisible') || tooltip.style.display === 'none') {
        // Tooltip ist bereits relativ positioniert via CSS (absolute, bottom-full, left-1/2)
        // Keine manuelle Positionierung nötig, da es relativ zum Parent-Container ist
        tooltip.style.display = 'block'
        tooltip.classList.remove('opacity-0', 'invisible', 'pointer-events-none')
        tooltip.classList.add('opacity-100', 'visible', 'pointer-events-auto')
        
        // Event Listener nur hinzufügen wenn Tooltip sichtbar ist
        if (!this.boundClickOutside) {
          this.boundClickOutside = this.clickOutside.bind(this)
          // Capture phase verwenden, damit wir vor anderen Event Handlern sind
          document.addEventListener('click', this.boundClickOutside, true)
        }
      } else {
        tooltip.classList.add('opacity-0', 'invisible', 'pointer-events-none')
        tooltip.classList.remove('opacity-100', 'visible', 'pointer-events-auto')
        tooltip.style.display = 'none'
        
        // Event Listener entfernen wenn Tooltip versteckt ist
        if (this.boundClickOutside) {
          document.removeEventListener('click', this.boundClickOutside, true)
          this.boundClickOutside = null
        }
      }
    })
  }
}
